import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core'
import { FormHelperService } from '../../services/form-helper.service'
import { ErrorService } from '../../services/error.service'
import Timer = NodeJS.Timer

@Component({
    selector: 'mg-ui-button',
    templateUrl: './ui-button.component.html',
    styleUrls: ['./ui-button.component.scss'],
})
export class UiButtonComponent {
    @Input()
    type: 'button' | 'submit' = 'button'
    @Input()
    isGhost: boolean = false
    @Input()
    greenTheme: boolean = false
    @Input()
    yellowTheme: boolean = false
    @Input()
    useArrow: boolean = true
    @Input()
    disabled: boolean = false
    @Input()
    linkTarget: string | null = null
    @Input()
    target: '_blank' | '_self' = '_self'
    @Input()
    isLoading: boolean = false
    @Input()
    download: false | string = false
    @Input()
    scrollToInvalid = false
    @Input()
    buttonColor = ''
    @Input()
    identifier = ''
    @Input()
    errorMessage = ''
    @Input()
    duration = 2000

    @HostBinding('class.ui-button--simplified-on-mobile')
    @Input()
    simplifyMobileStyling = false

    @Output()
    // eslint-disable-next-line @angular-eslint/no-output-native
    click = new EventEmitter()
    @Output()
    disabledClick = new EventEmitter()

    shakeIt: boolean = false
    shakeItTimer: number | Timer

    get isExternalLink() {
        return (
            this.linkTarget &&
            this.linkTarget.startsWith &&
            (this.linkTarget.startsWith('http') || this.linkTarget.startsWith('mailto'))
        )
    }

    constructor(private formHelperService: FormHelperService, private errorService: ErrorService) {}

    @HostListener('click', ['$event'])
    onHostClick($event: Event) {
        if ((this.type !== 'submit' || this.disabled) && $event) {
            $event.stopPropagation()
            $event.stopImmediatePropagation()
            $event.preventDefault()
            return false
        }
    }

    onWrapperClick($event, errorMessage, duration) {
        if (errorMessage) {
            this.errorService.createMessage({ message: errorMessage, actionFn: null, duration: duration || 2000 })
        }

        if (this.disabled) {
            $event.stopPropagation()
            $event.stopImmediatePropagation()
            $event.preventDefault()

            this.shakeIt = false
            clearTimeout(+this.shakeItTimer)

            this.shakeItTimer = setTimeout(() => {
                this.shakeIt = true

                this.shakeItTimer = setTimeout(() => {
                    this.shakeIt = false
                }, 2000)
            })

            if (this.scrollToInvalid) {
                this.formHelperService.scrollToInvalidElement()
            }

            this.disabledClick.emit()
        }
    }

    onButtonClick($event) {
        $event.stopPropagation()
        $event.stopImmediatePropagation()

        if (!this.disabled) {
            this.click.emit()
        }
    }
}
